export function linkToArticle() {
	const contentArea = document.querySelector('.post-template .single-content');

	if (contentArea) {
		contentArea.addEventListener('click', function (e) {
			const target = e.target.closest('a');
			if (target && contentArea.contains(target)) {
				e.preventDefault(); // Megakadályozza az alapértelmezett működést
				window.open(target.href, '_blank');
			}
		});
	}
}